module.exports = "/_next/static/images/WantToRetainCustomers-xs@2x-1f212308d7a603431fb930850a53eb77.webp";